"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var nestedComponent_1 = tslib_1.__importDefault(require("../utils/nestedComponent"));
var warning_1 = tslib_1.__importDefault(require("../utils/warning"));
var Caption_1 = tslib_1.__importDefault(require("./Caption"));
var Heading_1 = tslib_1.__importDefault(require("./Heading"));
var Paragraph_1 = tslib_1.__importDefault(require("./Paragraph"));
var Subtitle_1 = tslib_1.__importDefault(require("./Subtitle"));
var SUPPORTED_COLORS = [
    'primary',
    'inherit',
    'neutralColor.low.pure',
    'neutralColor.low.light',
    'neutralColor.low.medium',
    'neutralColor.low.dark',
    'neutralColor.high.pure',
    'neutralColor.high.light',
    'neutralColor.high.medium',
    'neutralColor.high.dark'
];
var SUPPORTED_MARGINS = [
    'quarck',
    'nano',
    'xxxs',
    'xxs',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',
    'xxxl',
    'huge',
    'giant'
];
var Typography = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.as, Tag = _c === void 0 ? 'p' : _c, className = _a.className, props = tslib_1.__rest(_a, ["as", "className"]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _d = props.size, size = _d === void 0 ? 'xs' : _d, _e = props.lineHeight, lineHeight = _e === void 0 ? 'md' : _e, _f = props.weight, weight = _f === void 0 ? 'regular' : _f, _g = props.color, color = _g === void 0 ? 'neutralColor.low.pure' : _g, _h = props.marginBottom, marginBottom = _h === void 0 ? false : _h, forwardProps = tslib_1.__rest(props, ["size", "lineHeight", "weight", "color", "marginBottom"]);
    var margin = marginBottom === true ? 'nano' : marginBottom === false ? null : marginBottom;
    return ((0, jsx_runtime_1.jsx)(Tag, tslib_1.__assign({ ref: ref, className: (0, houston_styles_1.cx)(className, (_b = {},
            _b["hst-typography-size-".concat(size)] = true,
            _b["hst-typography-line-".concat(lineHeight)] = true,
            _b["hst-typography-weight-".concat(weight)] = true,
            _b["hst-typography-margin-".concat(margin)] = !!margin,
            _b["hst-typography-color-".concat(getColorName(color))] = true,
            _b)) }, forwardProps)));
});
function getColorName(color) {
    return color.replace(/\./gim, '-');
}
function getColor(theme, color) {
    var _a, _b;
    if (color === 'inherit') {
        return 'inherit';
    }
    if (color === 'primary') {
        return theme.brandColor.primary.pure;
    }
    var _c = tslib_1.__read(color.split('.'), 3), themeColor = _c[0], level = _c[1], variable = _c[2];
    var result = (_b = (_a = theme[themeColor]) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b[variable];
    if (!result) {
        (0, warning_1.default)('Typography', "invalid color ".concat(color));
    }
    return result;
}
var TypographyWrapper = (0, houston_styles_1.default)(Typography, { label: 'hst-typography-typography' })(function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n    margin: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    margin: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), Object.keys(theme.font.size).map(function (size) { return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        &.hst-typography-size-", " {\n          font-size: ", ";\n        }\n      "], ["\n        &.hst-typography-size-", " {\n          font-size: ", ";\n        }\n      "])), size, theme.font.size[size]); }), Object.keys(theme.line.height).map(function (lineHeight) { return (0, houston_styles_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n        &.hst-typography-line-", " {\n          line-height: ", ";\n        }\n      "], ["\n        &.hst-typography-line-", " {\n          line-height: ", ";\n        }\n      "])), lineHeight, theme.line.height[lineHeight]); }), Object.keys(theme.font.weight).map(function (weight) { return (0, houston_styles_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n        &.hst-typography-weight-", " {\n          font-weight: ", ";\n        }\n      "], ["\n        &.hst-typography-weight-", " {\n          font-weight: ", ";\n        }\n      "])), weight, theme.font.weight[weight]); }), SUPPORTED_COLORS.map(function (color) { return (0, houston_styles_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n        &.hst-typography-color-", " {\n          color: ", ";\n        }\n      "], ["\n        &.hst-typography-color-", " {\n          color: ", ";\n        }\n      "])), getColorName(color), getColor(theme, color)); }), SUPPORTED_MARGINS.map(function (margin) { return (0, houston_styles_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n        &.hst-typography-margin-", " {\n          margin-bottom: ", ";\n        }\n      "], ["\n        &.hst-typography-margin-", " {\n          margin-bottom: ", ";\n        }\n      "])), margin, theme.spacing[margin]); }));
});
/**
 * @deprecated Use Typography from Antd
 * https://ant.design/components/typography/
 */
exports.default = (0, nestedComponent_1.default)(TypographyWrapper, {
    Caption: Caption_1.default,
    Heading: Heading_1.default,
    Paragraph: Paragraph_1.default,
    Subtitle: Subtitle_1.default
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
